import {
  getContrastText
} from "./chunk-6AMA4GNY.js";
import {
  __commonJS,
  __toESM
} from "./chunk-PLDDJCW6.js";

// ../../node_modules/hex-rgb/index.js
var require_hex_rgb = __commonJS({
  "../../node_modules/hex-rgb/index.js"(exports, module) {
    "use strict";
    var hexCharacters = "a-f\\d";
    var match3or4Hex = `#?[${hexCharacters}]{3}[${hexCharacters}]?`;
    var match6or8Hex = `#?[${hexCharacters}]{6}([${hexCharacters}]{2})?`;
    var nonHexChars = new RegExp(`[^#${hexCharacters}]`, "gi");
    var validHexSize = new RegExp(`^${match3or4Hex}$|^${match6or8Hex}$`, "i");
    module.exports = (hex, options = {}) => {
      if (typeof hex !== "string" || nonHexChars.test(hex) || !validHexSize.test(hex)) {
        throw new TypeError("Expected a valid hex string");
      }
      hex = hex.replace(/^#/, "");
      let alphaFromHex = 1;
      if (hex.length === 8) {
        alphaFromHex = Number.parseInt(hex.slice(6, 8), 16) / 255;
        hex = hex.slice(0, 6);
      }
      if (hex.length === 4) {
        alphaFromHex = Number.parseInt(hex.slice(3, 4).repeat(2), 16) / 255;
        hex = hex.slice(0, 3);
      }
      if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
      }
      const number = Number.parseInt(hex, 16);
      const red = number >> 16;
      const green = number >> 8 & 255;
      const blue = number & 255;
      const alpha = typeof options.alpha === "number" ? options.alpha : alphaFromHex;
      if (options.format === "array") {
        return [red, green, blue, alpha];
      }
      if (options.format === "css") {
        const alphaString = alpha === 1 ? "" : ` / ${Number((alpha * 100).toFixed(2))}%`;
        return `rgb(${red} ${green} ${blue}${alphaString})`;
      }
      return { red, green, blue, alpha };
    };
  }
});

// src/theme/colors.ts
var import_hex_rgb = __toESM(require_hex_rgb(), 1);
import varnishTheme from "@allenai/varnish-theme/mui";
var RGBA = class {
  constructor(r, g, b, a) {
    this.r = r;
    this.g = g;
    this.b = b;
    this.a = a;
  }
  toString() {
    return `rgba(${this.r}, ${this.g}, ${this.b}, ${this.a})`;
  }
};
function hexToRgb(hex) {
  const rgba = (0, import_hex_rgb.default)(hex);
  return new RGBA(rgba.red, rgba.green, rgba.blue, rgba.alpha);
}
var Color = class {
  displayName;
  hex;
  rgba;
  useContrastText;
  contrastTextColor;
  constructor(displayName, hex, rgba, useContrastText) {
    this.displayName = displayName;
    this.hex = hex.toUpperCase();
    this.rgba = rgba || hexToRgb(hex);
    this.useContrastText = useContrastText ?? false;
    this.contrastTextColor = getContrastText(this.hex);
  }
  toString() {
    return this.hex;
  }
};
var getColor = (color3) => {
  const c = color3.attributes;
  const rgba = new RGBA(c.rgb.r, c.rgb.g, c.rgb.b, c.rgb.a);
  const useContrastText = "useContrastText" in c ? c.useContrastText : false;
  const colorName = color3.name.replace("color-", "");
  const displayName = colorName.match(/^\D\d+$/) ? colorName.toUpperCase() : colorName;
  return new Color(displayName, `#${c.hex.toUpperCase()}`, rgba, useContrastText);
};
var getColor2 = (color2Type, c) => {
  return new Color(color2Type, c.hex, c.rgba, c.useContrastText);
};
var color = Object.entries(varnishTheme.color).reduce(
  (acc, [k, v]) => {
    acc[k] = getColor(v);
    return acc;
  },
  // https://github.com/typescript-eslint/typescript-eslint/issues/3440
  // eslint-disable-next-line @typescript-eslint/prefer-reduce-type-parameter
  {}
);
var isVarnishColor = (id) => {
  return id in color2;
};
var getUpdatedColor = (color22) => {
  return Object.values(color).filter((c) => c.hex === color22.hex)[0] || null;
};
var getLegacyColor = (color1) => {
  return Object.values(color2).filter((c) => c.hex === color1.hex)[0] || null;
};
var color2 = {
  R1: getColor2("R1", color.R2),
  R2: getColor2("R2", color.R4),
  R3: getColor2("R3", color.R6),
  R4: getColor2("R4", color.R8),
  R5: getColor2("R5", color.R10),
  O1: getColor2("O1", color.O2),
  O2: getColor2("O2", color.O4),
  O3: getColor2("O3", color.O6),
  O4: getColor2("O4", color.O8),
  O5: getColor2("O5", color.O9),
  G1: getColor2("G1", color.G2),
  G2: getColor2("G2", color.G4),
  G3: getColor2("G3", color.G6),
  G4: getColor2("G4", color.G8),
  G5: getColor2("G5", color.G10),
  T1: getColor2("T1", color.T1),
  T2: getColor2("T2", color.T3),
  T3: getColor2("T3", color.T6),
  T4: getColor2("T4", color.T8),
  T5: getColor2("T5", color.T10),
  A1: getColor2("A1", color.A1),
  A2: getColor2("A2", color.A3),
  A3: getColor2("A3", color.A5),
  A4: getColor2("A4", color.A8),
  A5: getColor2("A5", color.A10),
  B1: getColor2("B1", color.B1),
  B2: getColor2("B2", color.B3),
  B3: getColor2("B3", color.B6),
  B4: getColor2("B4", color.B8),
  B5: getColor2("B5", color.B10),
  P1: getColor2("P1", color.P2),
  P2: getColor2("P2", color.P4),
  P3: new Color("P3", "#7446F2", void 0, true),
  // there was no matching varnish1 color
  P4: getColor2("P4", color.P8),
  P5: getColor2("P5", color.P10),
  F1: getColor2("F1", color.M1),
  F2: getColor2("F2", color.M4),
  F3: getColor2("F3", color.M6),
  F4: getColor2("F4", color.M8),
  F5: getColor2("F5", color.M10),
  N1: getColor2("N1", color.N2),
  N2: getColor2("N2", color.N4),
  N3: getColor2("N3", color.N6),
  N4: getColor2("N4", color.N8),
  N5: getColor2("N5", color.N9),
  black: getColor2("black", color.black),
  white: getColor2("white", color.white),
  transparent: getColor2("transparent", color.transparent)
};
var lightCategoricalColor = {
  Red: { ...color.R10, displayName: "Red" },
  Orange: { ...color.O9, displayName: "Orange" },
  Aqua: { ...color.A10, displayName: "Aqua" },
  Teal: { ...color.T8, displayName: "Teal" },
  Blue: { ...color.B6, displayName: "Blue" },
  Magenta: { ...color.M10, displayName: "Magenta" },
  Purple: { ...color.P8, displayName: "Purple" },
  Green: { ...color.G10, displayName: "Green" }
};
var darkCategoricalColor = {
  Red: { ...color.R4, displayName: "Red" },
  Orange: { ...color.O4, displayName: "Orange" },
  Aqua: { ...color.A3, displayName: "Aqua" },
  Teal: { ...color.T3, displayName: "Teal" },
  Blue: { ...color.B3, displayName: "Blue" },
  Magenta: { ...color.M4, displayName: "Magenta" },
  Purple: { ...color.P4, displayName: "Purple" },
  Green: { ...color.G4, displayName: "Green" }
};
var colorsIdsToHexVals = (colorIds) => colorIds.map((k) => color[k].hex);
var colorMapToHexVals = (colorMap) => Object.values(colorMap).map((v) => v.hex);

export {
  RGBA,
  hexToRgb,
  Color,
  color,
  isVarnishColor,
  getUpdatedColor,
  getLegacyColor,
  color2,
  lightCategoricalColor,
  darkCategoricalColor,
  colorsIdsToHexVals,
  colorMapToHexVals
};
//# sourceMappingURL=chunk-JTRNFWOO.js.map